import { Link } from 'react-router-dom';
import './SetupAgentPage.css';
import './ViewAgentPage.css';

const BusinessAdminPage = () => {
  const userString = localStorage.getItem('user');
  const user = userString ? JSON.parse(userString) : {};
  const role = user.role || 'STANDARD';
  const isAdmin = role === 'ADMIN';

  const businessAdmin = [
    {
      id: 1,
      title: 'View Agents',
      description: 'View and search existing Amazon Connect agent configurations',
      icon: '\uD83D\uDD0D',
      path: '/view-agents',
      color: '#ff9800',
    },
    {
      id: 2,
      title: 'Reports',
      description: 'Generate and download reports on agent activity and configurations',
      icon: '\uD83D\uDCCA',
      path: '/reports',
      color: '#9c27b0',
    },
    {
      id: 3,
      title: 'Custom Routing Administration',
      description: 'Manage Routing Restrictions',
      icon: '\u2699\uFE0F',
      path: '/routing-admin',
      color: '#608b80',
    },
    {
      id: 4,
      title: 'AWS Connect Archive / Restore',
      description: 'Manage AWS Connect archive and restore operations',
      icon: '	\uD83D\uDCBD',
      path: '/archive-management',
      color: '#200bd8',
    },
    {
      id: 5,
      title: 'Prototype Agent Re-Route',
      description: 'Prototype and manage agent re-routing configurations',
      icon: '	\uD83D\uDD04',
      path: '/prototype-agent-re-route',
      color: '#200bd8',
    }
  ]

   const standardBusiness = [
    {
      id: 1,
      title: 'View Agents',
      description: 'View and search existing Amazon Connect agent configurations',
      icon: '\uD83D\uDD0D',
      path: '/view-agents',
      color: '#ff9800',
    },
    {
      id: 2,
      title: 'Reports',
      description: 'Generate and download reports on agent activity and configurations',
      icon: '\uD83D\uDCCA',
      path: '/reports',
      color: '#9c27b0',
    },
   ];

  const features = isAdmin ? businessAdmin : standardBusiness;

  return (
    <div className="setup-page">
      <div className="page-header">
        <div>
           <h1>Business Administration</h1>
           <p className="home-subtitle">
            {isAdmin
              ? 'You have administrator access to manage business administration tasks'
              : 'You have standard access to manage business administration tasks'}
           </p>
        </div>
        <Link to="/home" className="btn btn-secondary">
            ← Back to Home
        </Link>
      </div>

      <div className="features-grid">
          {features.map((feature) => {
            if (feature.comingSoon) {
              return (
                <div
                  key={feature.id}
                  className="feature-card feature-card-disabled"
                  style={{ '--feature-color': feature.color }}
                >
                  <div className="feature-icon">{feature.icon}</div>
                  <h3 className="feature-title">{feature.title}</h3>
                  <p className="feature-description">{feature.description}</p>
                  <span className="coming-soon-badge">Coming Soon</span>
                </div>
              );
            }

            return (
              <Link
                key={feature.id}
                to={feature.path}
                className="feature-card"
                style={{ '--feature-color': feature.color }}
              >
                <div className="feature-icon">{feature.icon}</div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
                <span className="feature-arrow">&rarr;</span>
              </Link>
            );
          })}
        </div>
  
        <div className="home-info">
          <h2>User Profile</h2>
          <div className="info-grid">
            <div className="info-card">
              <h3>Name</h3>
              <p>{user.name || 'N/A'}</p>
            </div>
            <div className="info-card">
              <h3>Email</h3>
              <p>{user.email || 'N/A'}</p>
            </div>
            <div className="info-card">
              <h3>LAN ID</h3>
              <p>{user.lan_id || 'N/A'}</p>
            </div>
            <div className="info-card">
              <h3>Role</h3>
              <p>{role}</p>
            </div>
          </div>
        </div>
    </div>
  );
};

export default BusinessAdminPage;